import * as React from 'react';
import { useHistory } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { Link } from 'react-router-dom';
import FormDialog from '../LoginDialog/LoginDialog';
import { Button } from '@mui/material';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../config/firebaseConfig.js';

export default function MenuAppBar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const history = useHistory();

  React.useEffect(
    () =>
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser({
            name: user.displayName,
            email: user.email,
            photoUrl: user.photoURL,
          });
        } else {
          setUser(null);
          history.push('/');
        }
      }),
    [history]
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          position="static"
          style={{ backgroundColor: '#FF6347', padding: '5px 0' }}
        >
          <Toolbar>
            <Link to="/">
              <div
                style={{
                  width: '150px',
                  cursor: 'pointer',
                }}
              >
                <img
                  style={{ width: '100%' }}
                  src="../images/logos/logo.png"
                  alt="logo"
                />
              </div>
            </Link>

            <Typography
              variant="h5"
              component="div"
              sx={{ flexGrow: 1 }}
            ></Typography>
            {user ? (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  {user.photoUrl ? (
                    <div className="user">
                      <img src={user?.photoUrl} alt={user.name} />
                    </div>
                  ) : (
                    <AccountCircle />
                  )}
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => signOut(auth)}>Logout</MenuItem>

                  <MenuItem onClick={handleClose}>
                    <Link
                      to="/dashboard"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      Dashboard
                    </Link>
                  </MenuItem>
                </Menu>
              </div>
            ) : (
              <Button variant="contained" onClick={handleClickOpen}>
                Login
              </Button>
            )}
          </Toolbar>
        </AppBar>
      </Box>
      <FormDialog
        open={open}
        handleClose={handleClose}
        handleClickOpen={handleClickOpen}
        setOpen={setOpen}
      />
    </React.Fragment>
  );
}
